/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * Shore Power Hub API
 * Shore Power Hub provides the backend services for Plug Insight. <br><br>The spec is available at \<this URL\>/swagger.json.
 * OpenAPI spec version: 2
 */
import { useCallback } from "react";
import {
  useMutation,
  type MutationFunction,
  type QueryClient,
  type UseMutationOptions,
  type UseMutationResult,
} from "@tanstack/react-query";

import {
  useOrvalAxiosInstance,
  type BodyType,
  type ErrorType,
} from "../../useOrvalAxios";
import type { ApitypeAppError2, HandlersSupportRequest } from "./models";

/**
 * @summary Send a support request - WIP
 */
export const useSendasupportrequestWIPHook = () => {
  const sendasupportrequestWIP = useOrvalAxiosInstance<void>();

  return useCallback(
    (
      handlersSupportRequest: BodyType<HandlersSupportRequest>,
      signal?: AbortSignal,
    ) => {
      return sendasupportrequestWIP({
        url: `/api/v2/support`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: handlersSupportRequest,
        signal,
      });
    },
    [sendasupportrequestWIP],
  );
};

export const useSendasupportrequestWIPMutationOptions = <
  TError = ErrorType<ApitypeAppError2>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useSendasupportrequestWIPHook>>>,
    TError,
    { data: BodyType<HandlersSupportRequest> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useSendasupportrequestWIPHook>>>,
  TError,
  { data: BodyType<HandlersSupportRequest> },
  TContext
> => {
  const mutationKey = ["sendasupportrequestWIP"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const sendasupportrequestWIP = useSendasupportrequestWIPHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useSendasupportrequestWIPHook>>>,
    { data: BodyType<HandlersSupportRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return sendasupportrequestWIP(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendasupportrequestWIPMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useSendasupportrequestWIPHook>>>
>;
export type SendasupportrequestWIPMutationBody =
  BodyType<HandlersSupportRequest>;
export type SendasupportrequestWIPMutationError = ErrorType<ApitypeAppError2>;

/**
 * @summary Send a support request - WIP
 */
export const useSendasupportrequestWIP = <
  TError = ErrorType<ApitypeAppError2>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useSendasupportrequestWIPHook>>>,
      TError,
      { data: BodyType<HandlersSupportRequest> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useSendasupportrequestWIPHook>>>,
  TError,
  { data: BodyType<HandlersSupportRequest> },
  TContext
> => {
  const mutationOptions = useSendasupportrequestWIPMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
